import { Block, Calendar, PrensaEngine } from '@xprog/prensa'
import React from 'react'

import { DatePickerProps } from './DatePicker.types'

const Label = PrensaEngine.styled('label', {})

const DatePicker: React.FC<DatePickerProps> = ({ css, ...otherProps }) => {

  const style = {
    ...css?.picker,
    container: {
      maxWidth: 'unset',
      borderRadius: '$alternative',
      borderColor: '#e6e6e6',
      mt: '$1',
      ...css?.picker?.container
    },
    dayGroup: {
      minWidth: '273px',
      ...css?.picker?.dayGroup
    },
    dayButton: {
      fontFamily: '$primary',
      fontSize: '$caption2',
      fontWeight: '$caption2',
      lineHeight: '$caption2',
      '&[data-selected-state=true]': {
        color: '$basicWhite',
        backgroundColor: '$primaryMain',
        borderRadius: '$alternative',
      },
      ...css?.picker?.dayButton
    }
  }

  return (
    <Block
      css={css?.container}
    >
      <Label
        css={{
          fontFamily: '$primary',
          fontSize: '16px',
          fontWeight: '500',
          ml: '$3',
          ...css?.label
        }}
      >
        Por data:
      </Label>
      <Calendar
        css={style}
        {...otherProps}
      />
    </Block>
  )
}

export default DatePicker